import {Controller} from "stimulus"
import $ from 'jquery';
import toastr from 'toastr/toastr'
import bootbox from 'bootbox/bootbox';
import 'toastr/toastr.scss'

require('leaflet/dist/leaflet.css')
import 'leaflet'
import {OpenStreetMapProvider} from 'leaflet-geosearch'
const provider = new OpenStreetMapProvider();

//Variables
let map = '';
let edit_map = '';
let marker = [];
// let latlngs = [[23.916, -73.537],
//     [19.421, -86.155]];

let latlngs = [[24.000, -73.619],
    [19.300, -85.590]];

function getPointData(lat, lng, latlng, addrs = null,popup = null) {
    var reversegeocode = 'https://nominatim.openstreetmap.org/reverse?format=json&lat='+lat+'&lon='+lng+'&zoom=18&addressdetails=1'; //alert(reversegeocode);
    $.getJSON(reversegeocode, function(data) {
        var msg = `${data.display_name} <br> <span class="helper_text small">Esta dirección es autogenerada, revise el campo de dirección en el formulario para verificar que sea la correcta.</span>`;
        if(addrs !== null){
            addrs.value = data.display_name
        }

        if(popup !== null){
            popup
                .setLatLng(latlng)
                .setContent(msg)
                .openOn(edit_map);
        }


    });
}

let create_mark = (array, icon) => {
    array.map(elem => {
        if (elem.latitude !== "0.0" && elem.longitude !== "0.0") {
            let open_time = `${elem.open_time}am - ${elem.close_time}px`;

            if (elem.full_time) {
                open_time = '24 horas';
            }

            let mark = L.marker([parseFloat(elem.latitude), parseFloat(elem.longitude)], {
                draggable: false,
                icon: icon,
                title: `${elem.dealer}. Click para ver más detalles...`,
                alt: ''
            });
            marker.push(mark);
            map.addLayer(mark);
            mark.bindPopup(`<h3>${elem.name}</h3>
                                <br><strong>Telefono:</strong> ${elem.phones}
                                <br><strong>Horario:</strong> ${open_time}
                                <br><strong>Dirección:</strong> ${elem.address}`);
        }
    })
}

export default class extends Controller {
    initialize() {
        setTimeout(()=>{
            let edit_maps = $('#edit_map')[0]
            let icon_map = this.element.dataset.icon;

            //EDIT MAP
            if (edit_maps !== undefined) {
                let lat = document.getElementById('admin_locaciones_extra_latitude');
                let lng = document.getElementById('admin_locaciones_extra_longitude');
                let addrs = document.getElementById('admin_locaciones_extra_address');

                edit_map = L.map('edit_map', {
                    zoom: 7.75,
                    minZoom: 7.75,
                    zoomSnap: 0.50,
                    scrollWheelZoom: true,
                    touchZoom: false,
                });


                if ((lat !== undefined && lng !== undefined) && (lat.value !== "0.0" && lng.value !== "0.0")) {
                    edit_map.setView([parseFloat(lat.value), parseFloat(lng.value)], 19);

                    //MARCADORES E ICONOS
                    var myIcon = L.icon({
                        iconUrl: icon_map,
                        popupAnchor: [-3, -3],
                        iconSize: [25, 32],
                    });

                    L.marker([parseFloat(lat.value), parseFloat(lng.value)], {
                        draggable: false,
                        icon: myIcon,
                        title: 'Click para ver más detalles...',
                        alt: ''
                    }).addTo(edit_map).bindPopup(`<h3>${document.getElementById('admin_locaciones_extra_name').value}</h3>`);
                } else {
                    edit_map.fitBounds(latlngs)
                }


                //Agregando capa OpenStreetMap
                L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://cloudmade.com">CloudMade</a>',
                    maxZoom: 25
                }).addTo(edit_map);

                // popup para la direccion
                var popup = L.popup();

                edit_map.on('click', function (event) {
                    lat.value = event.latlng.lat;
                    lng.value = event.latlng.lng;

                    getPointData(event.latlng.lat,event.latlng.lng,event.latlng, addrs, popup);
                })


                lat.addEventListener('keyup', function (e) {
                    if((e.target.value !== null && lng !== null) && (e.target.value !== "0.0" && lng.value !== "0.0")){
                        if(!e.target.value.isEmpty() && !lng.value.isEmpty()){
                            edit_map.setView([parseFloat(e.target.value), parseFloat(lng.value)], 15);

                            getPointData(e.target.value, lng.value,{lat: e.target.value, lng: lng.value}, addrs, popup)
                        }
                    }
                })

                lng.addEventListener('keyup', function (e) {
                    if((e.target.value !== null && lat !== null) && (e.target.value !== "0.0" && lat.value !== "0.0")){
                        if(!e.target.value.isEmpty() && !lat.value.isEmpty()){
                            edit_map.setView([parseFloat(lat.value), parseFloat(e.target.value)], 15);

                            getPointData(lat.value,e.target.value,{lat: lat.value, lng: e.target.value}, addrs, popup)
                        }
                    }
                })
            }
        },500)

    }

    connect() {

    }

}